import React, { useCallback } from 'react';
import {
  Box,
  Chip,
  Stack,
  Divider,
  useMediaQuery,
  useTheme,
  Select,
  MenuItem,
  FormControl,
} from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';

const chanceStatus = [
  { id: 0, value: '', label: '전체', color: 'warning' },
  { id: 1, value: '1', label: '기회확인', color: 'info' },
  { id: 2, value: '2', label: '기회분석', color: 'error' },
  { id: 3, value: '3', label: '매출견적', color: 'success' },
  { id: 4, value: '4', label: '수주품의 ', color: 'secondary' },
];

const projectStatus = [
  { id: 0, value: '', label: '전체', color: 'warning' },
  { id: 1, value: '0', label: '수주품의', color: 'secondary' },
  { id: 2, value: '1', label: '발주', color: 'success' },
  { id: 3, value: '2', label: '세금계산서', color: 'error' },
  { id: 4, value: '3', label: '채권', color: 'primary' },
];

const prjTyps = [
  { id: 0, value: '', label: '전체', color: 'warning' },
  { id: 1, value: 'N', label: '프로젝트', color: 'info' },
  { id: 2, value: 'M', label: '유지보수', color: 'success' },
  { id: 3, value: 'ETC', label: '기타매출', color: 'secondary' },
];

const StatusList = ({ filters, onFilters, menu }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const satusList = menu === 'project' ? projectStatus : chanceStatus;

  // [추가] 현재 선택된 값의 객체 정보를 찾아주는 함수
  const getSelectedItem = (list, value) => list.find((item) => item.value === value) || list[0];

  const handleFilterType = useCallback((val) => {
    onFilters('searchPrjTyp', val);
  }, [onFilters]);

  const handleFilterStatus = useCallback((val) => {
    onFilters('searchGrade', val);
  }, [onFilters]);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center',
      }}
    >
      {isMobile ? (
        /* --- 모바일: 드롭다운 (현재 설정된 값 노출) --- */
        <Stack direction="row" spacing={1} sx={{ width: '100%' }}>
          {menu === 'chance' && (
            <FormControl fullWidth size="small">
              <Select
                value={filters.searchPrjTyp || ''}
                onChange={(e) => handleFilterType(e.target.value)}
                displayEmpty
                renderValue={(selected) => {
                  const item = getSelectedItem(prjTyps, selected);
                  return (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: '0.8rem' }}>
                      <CircleIcon sx={{ fontSize: 10, color: `${item.color}.main` }} />
                      {item.label}
                    </Box>
                  );
                }}
              >
                {prjTyps.map((st) => (
                  <MenuItem key={st.id} value={st.value} sx={{ fontSize: '0.8rem' }}>
                    <CircleIcon sx={{ fontSize: 10, mr: 1, color: `${st.color}.main` }} />
                    {st.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          <FormControl fullWidth size="small">
            <Select
              value={filters.searchGrade || ''}
              onChange={(e) => handleFilterStatus(e.target.value)}
              displayEmpty
              // [핵심] 선택된 값의 아이콘과 라벨을 상단에 렌더링
              renderValue={(selected) => {
                const item = getSelectedItem(satusList, selected);
                return (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: '0.8rem' }}>
                    <CircleIcon sx={{ fontSize: 10, color: `${item.color}.main` }} />
                    {item.label}
                  </Box>
                );
              }}
            >
              {satusList.map((st) => (
                <MenuItem key={st.id} value={st.value} sx={{ fontSize: '0.8rem' }}>
                  <CircleIcon sx={{ fontSize: 10, mr: 1, color: `${st.color}.main` }} />
                  {st.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Stack>
      ) : (
        /* --- 데스크탑: 기존 코드 및 CSS 유지 --- */
        <Stack
          direction="row"
          divider={<Divider orientation="vertical" flexItem />}
          spacing={1}
        >
          {menu === 'chance' && (
            <Box>
              {prjTyps &&
                prjTyps.map((st, index) => (
                  <Chip
                    sx={{ mr: 2 }}
                    key={index}
                    icon={<CircleIcon />}
                    label={st.label}
                    variant={st.value === filters.searchPrjTyp ? 'contained' : 'outlined'}
                    color={st.color}
                    onClick={() => handleFilterType(st.value)}
                  />
                ))}
            </Box>
          )}
          <Box sx={{ display: 'flex' }}>
            {satusList &&
              satusList.map((st, index) => (
                <Chip
                  sx={{ ml: 2 }}
                  key={index}
                  icon={<CircleIcon />}
                  label={st.label}
                  variant={st.value === filters.searchGrade ? 'contained' : 'outlined'}
                  color={st.color}
                  onClick={() => handleFilterStatus(st.value)}
                />
              ))}
          </Box>
        </Stack>
      )}
    </Box>
  );
};

export default StatusList;
